const sizeValues = {
  none: 0,
  xxs: 0.125,
  xs: 0.25,
  s: 0.5,
  m: 1,
  l: 1.5,
  xl: 2,
  xxl: 2.5
};
const sizeNames = Object.keys(sizeValues);

// Create the core size tokens
const core = sizeNames.reduce((sizeTokens, size) => {
  sizeTokens[size] = `${sizeValues[size]}rem`;
  return sizeTokens;
}, {});

// Create the block tokens
const block = sizeNames.reduce((sizeTokens, size) => {
  sizeTokens[size] = `${sizeValues[size]}rem`;
  return sizeTokens;
}, {});

// Create the inline tokens
const inline = sizeNames.reduce((sizeTokens, size) => {
  sizeTokens[size] = `${sizeValues[size]}rem`;
  return sizeTokens;
}, {});

// Create the inset-squish tokens
const insetSquish = sizeNames.reduce((spacingTokens, size) => {
  spacingTokens[size] = {
    padding: `${0.5 * sizeValues[size]}rem ${core[size]}`
  };
  return spacingTokens;
}, {});

// Create the inset-stretch tokens
const insetStretch = sizeNames.reduce((spacingTokens, size) => {
  spacingTokens[size] = {
    padding: `${core[size]} ${0.5 * sizeValues[size]}rem`
  };
  return spacingTokens;
}, {});
export const spacing = {
  core,
  block,
  inline,
  insetSquish,
  insetStretch,
  size: {
    none: '0',
    xxs: '96px',
    xs: '192px',
    s: '240px',
    m: '320px',
    l: '400px',
    xl: '640px',
    xxl: '960px'
  }
};
//# sourceMappingURL=spacing.js.map